import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import SelectableGoal from './SelectableGoal'
import { mainGoalsList, mainGoalsListNew, agendaGoalsList } from '../../../constants/GoalsMap'
import Tooltip from '../tooltip/Tooltip'
import translate from '../../reusable/translate'
import commitmentSlice from '../../../state/slices/commitmentSlice'
import validatorSlice from "../../../state/slices/validatorSlice";
import {isMaterialOrGD} from "../helpers/Categories";

const AgendaContainer = ({ fetchedCommitment, mainGoal }) => {
    const { commitment } = useSelector((state) => state)
    const dispatch = useDispatch()
    const { setCategoryIds } = bindActionCreators(commitmentSlice.actions, dispatch)
    const { changeMainGoalValidator } = bindActionCreators(validatorSlice.actions, dispatch)

    const [mainGoalList, setMainGoalList] = useState( (mainGoalsList.find(element => element.categoryId === mainGoal ) ? mainGoalsList : mainGoalsListNew ))
    const [agendaGoalList, setAgendaGoalList] = useState(agendaGoalsList)
    const [secondaryGoalIds, setSecondaryGoalIds] = useState([]) // ID listing for secondaryGoals
    const [agendaGoalIds, setAgendaGoalIds] = useState([]) // ID listing for agendaGoals
    const [selectedMainGoal, setSelectedMainGoal] = useState(undefined)

    /* Finds main goal's agenda goal listing and concats it to agendaGoalsIds */
    useEffect(() => {
        if(mainGoal) {
            setAgendaGoalIds(agendaGoalIds
                .concat(mainGoalList
                    .find((mappedGoal) => mappedGoal.categoryId === mainGoal).agendaGoals))
            changeMainGoalValidator(true)
        }
        /* If categoryIds array is not empty, find and set secondary and agenda goals from it. Used while editing the commitment */
        if (commitment.categoryIds && commitment.categoryIds.length > 1) {
            if(mainGoal) {
                setSecondaryGoalIds(mainGoalList
                    .filter((mappedGoal) => commitment.categoryIds
                        .includes(mappedGoal.asSecondaryGoal))
                    .map((mappedGoal) => mappedGoal.asSecondaryGoal))
            } else{
                var mainGoalsFromCategoryIds = mainGoalList
                    .filter((mappedGoal) => commitment.categoryIds
                        .includes(mappedGoal.categoryId))
                    .map((mappedGoal) => mappedGoal.categoryId)
                if(mainGoalsFromCategoryIds && mainGoalsFromCategoryIds.length === 1){
                    setSelectedMainGoal(mainGoalsFromCategoryIds[0])
                    changeMainGoalValidator(true)
                }
                var secondaryGoalsFromCategoryIds = mainGoalList
                    .filter((mappedGoal) => commitment.categoryIds
                        .includes(mappedGoal.asSecondaryGoal))
                    .map((mappedGoal) => mappedGoal.asSecondaryGoal)
                setSecondaryGoalIds([...mainGoalsFromCategoryIds, ...secondaryGoalsFromCategoryIds])
            }
            setAgendaGoalIds(agendaGoalList
                .filter((mappedGoal) => commitment.categoryIds
                    .includes(mappedGoal.categoryId))
                .map((mappedGoal) => mappedGoal.categoryId))
        }
    }, [])

    const removeMainGoalCategory = (item) => {
        return mainGoalsList.filter((maingoalItem) => maingoalItem.categoryId === item || maingoalItem.asSecondaryGoal === item).length < 1 &&
            mainGoalsListNew.filter((maingoalItem) => maingoalItem.categoryId === item || maingoalItem.asSecondaryGoal === item).length < 1;
    }

    /* Concats content of multiple arrays into one and assigns it to the commitment as categoryIds */
    useEffect(() => {
        let ids = undefined
            if(commitment.commitmentType === 'COMMITMENT'){
                let generalCategories = fetchedCommitment.commitmentData.categoryIds.filter(removeMainGoalCategory)
                console.log("general", generalCategories)
                ids = [...new Set([mainGoal, ...secondaryGoalIds, ...agendaGoalIds, ...generalCategories])]

            } else{
                ids = [...new Set([mainGoal, ...secondaryGoalIds, ...agendaGoalIds, ...fetchedCommitment.commitmentData.categoryIds])]
            }
        setCategoryIds(ids)
    }, [secondaryGoalIds, agendaGoalIds])

    /* Changes the active status of mainGoals based on whether their IDs are on the list or not */
    useEffect(() => {
        setMainGoalList(mainGoalList
            .map((mappedGoal) => (secondaryGoalIds
                .includes(mappedGoal.asSecondaryGoal)
                || secondaryGoalIds.includes(mappedGoal.categoryId)
                || mappedGoal.categoryId === mainGoal
                || mappedGoal.categoryId === selectedMainGoal
                ? { ...mappedGoal, active: true }
                : { ...mappedGoal, active: false })))
    }, [secondaryGoalIds, selectedMainGoal])

    /* Changes the active status of agendaGoals based on whether their IDs are on the list or not */
    useEffect(() => {
        setAgendaGoalList(agendaGoalList
            .map((mappedGoal) => (agendaGoalIds
                .includes(mappedGoal.categoryId)
                ? { ...mappedGoal, active: true }
                : { ...mappedGoal, active: false })))
    }, [agendaGoalIds])

    /* Changes 'active' status of a goal if it is not the main goal */
    const modifySecondaryGoals = (goal) => {
        if (goal.categoryId !== mainGoal) {
            if (secondaryGoalIds.includes(goal.asSecondaryGoal)) {
                setSecondaryGoalIds(secondaryGoalIds.filter((mappedGoal) => mappedGoal !== goal.asSecondaryGoal))
            } else if (secondaryGoalIds.length < 3) {
                setSecondaryGoalIds(secondaryGoalIds.concat(goal.asSecondaryGoal))
            }
        }
    }

    /* Changes 'active' status of a goal if it is not the main goal */
    const modifyMainGoals = (goal) => {
            if (selectedMainGoal === goal.categoryId){
                if(secondaryGoalIds.length > 1){
                    // Cannot remove the maingoal before others
                  return
                } else{
                    setSecondaryGoalIds(secondaryGoalIds.filter((mappedGoal) => mappedGoal !== goal.categoryId))
                    setSelectedMainGoal(undefined);
                    changeMainGoalValidator(false)

                }
            } else if(!selectedMainGoal){
                setSelectedMainGoal(goal.categoryId);
                changeMainGoalValidator(true)
                setSecondaryGoalIds(secondaryGoalIds.concat(goal.categoryId))
            } else if(secondaryGoalIds.includes(goal.asSecondaryGoal)){
                setSecondaryGoalIds(secondaryGoalIds.filter((mappedGoal) => mappedGoal !== goal.asSecondaryGoal))
            }  else{
                setSecondaryGoalIds(secondaryGoalIds.concat(goal.asSecondaryGoal))
            }

    }

    /* Changes 'active' status of a goal if it is not part of the mainGoal's agenda listing */
    const modifyAgendaGoals = (goal) => {
        try {
            if (commitment.commitmentType !== "COMMITMENT" && !mainGoalList
                .find((mappedGoal) => mappedGoal.categoryId === mainGoal).agendaGoals
                .includes(goal.categoryId)) {

                if (agendaGoalIds.includes(goal.categoryId)) {
                    setAgendaGoalIds(agendaGoalIds.filter((agendaGoal) => agendaGoal !== goal.categoryId))
                } else {
                    setAgendaGoalIds(agendaGoalIds.concat(goal.categoryId))
                }
            } else if (commitment.commitmentType === "COMMITMENT"){
                if (agendaGoalIds.includes(goal.categoryId)) {
                    setAgendaGoalIds(agendaGoalIds.filter((agendaGoal) => agendaGoal !== goal.categoryId))
                } else {
                    setAgendaGoalIds(agendaGoalIds.concat(goal.categoryId))
                }
            }
        } catch (e) {
            if (agendaGoalIds.includes(goal.categoryId)) {
                setAgendaGoalIds(agendaGoalIds.filter((agendaGoal) => agendaGoal !== goal.categoryId))
            } else {
                setAgendaGoalIds(agendaGoalIds.concat(goal.categoryId))
            }
        }

    }

    return (
        <div className="border-bottom">
            <AgendaHeader
                mainGoal={mainGoal}
                mainGoalList={mainGoalList}
            />

            <MainGoalsContainer
                mainGoalList={mainGoalList}
                modifySecondaryGoals={mainGoal ? modifySecondaryGoals : modifyMainGoals}
                isMaterialOrGD={isMaterialOrGD(commitment.commitmentType)}
            />

            <AgendaGoalsContainer
                agendaGoalList={agendaGoalList}
                modifyAgendaGoals={modifyAgendaGoals}
            />
        </div>
    )
}

export default AgendaContainer

const AgendaHeader = ({ mainGoalList, mainGoal }) => {
    return(
        <div>
            <h3>{translate({textKey: 'sit.commitmentCreation.sustainableGoals'})}</h3>
            {mainGoal &&
            <div className="margin-top-bot">
                <p className="p">
                    Sitoumuksesi liittyy Suomen kestävän kehityksen tavoitteeseen
                    <b> {mainGoalList.find((goal) => Number(goal.categoryId) === mainGoal).name}. </b>
                    Voit valita myös muita Suomen kestävän kehityksen tavoitteita, jotka liittyvät sitoumukseesi.
                </p>
            </div>
            }
        </div>
    )
}

const MainGoalsContainer = ({ mainGoalList, modifySecondaryGoals, isMaterialOrGD }) => {
    return (
        <div className="section">
            <div className="flex-row items-center margin-top-bot">

                { isMaterialOrGD && <div className="w300">
                    <p className="p">{translate({ textKey: 'sit.commitmentCreation.selectSecondaryGoals' })}</p>
                    <Tooltip textKey="sit.commitment.chooseOtherInfo" />
                </div> }

                { !isMaterialOrGD && <div className="w300">
                    <p className="p">{translate({ textKey: 'sit.commitmentCreation.selectSecondaryGoals' })}</p>
                    <Tooltip textKey="sit.commitment.chooseOtherInfoCommitment" />
                </div> }
                {/* commitment.type === 'COMMITMENT' &&
                <div className="w300">
                    <p className="p">{translate({ textKey: 'sit.commitmentCreation.selectNewMainGoals' })}</p>
                    <Tooltip textKey="sit.commitment.chooseOtherInfo" />
                </div>
                */}
            </div>

            {!isMaterialOrGD &&
                <div className="flex-row items-center margin-top-bot">
                    <p className="p">{translate({ textKey: 'sit.commitmentCreation.maingoal.infotext' })}</p>
                </div>
            }

            {/* Displays main goals */}
            <div className="flex-row-wrap space-between row-margin">
                {mainGoalList
                    .map((goal) => (
                        <SelectableGoal
                            key={goal.categoryId}
                            src={goal.srcImg}
                            goal={goal}
                            size={100}
                            changeActiveState={modifySecondaryGoals}
                            isMainGoal
                            showHelper={!isMaterialOrGD}
                        />
                    ))}
            </div>
        </div>
    )
}

const AgendaGoalsContainer = ({ agendaGoalList, modifyAgendaGoals }) => {
    return (
        <div>
            <div className="w300 margin-top-bot">
                <p className="p">{translate({ textKey: 'sit.commitmentCreation.canSelect2030Goals' })}</p>
                <Tooltip textKey="sit.commitment.agenda2030Info" />
            </div>

            {/* Displays agenda goals */}
            <div className="grid6">
                {agendaGoalList
                    .map((goal) => (
                        <SelectableGoal
                            key={goal.categoryId}
                            src={goal.srcImg}
                            goal={goal}
                            size={150}
                            changeActiveState={modifyAgendaGoals}
                        />
                    ))}
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/components/materialCommitment/agenda/AgendaContainer.jsx